// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BeImS","colMin":"styles_colMin__2bM0U"};